module.exports = __webpack_public_path__ + "static/media/SERVICES_robot.7872bdf7.png";